import { faMessage } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
interface Props {
  className?: string
  cmtNumber: number
}
const CommentNumber = ({ className, cmtNumber }: Props) => {
  return (
    <div className={` flex items-center ${className}`}>
      <FontAwesomeIcon icon={faMessage} className="mr-2" />
      <span>{cmtNumber}</span>
    </div>
  )
}

export default CommentNumber
